<template>
  <div class="contract-form">
    <div class="left-panel" v-if="showConstructor">
      <div
        v-for="field in fields"
        :key="field.key"
        class="field-card"
      >
        <div class="card-content">
          <div class="field-title">{{ field.label }}</div>

          <select
            v-if="!field.multiple"
            :value="selections[field.key]"
            @change="(e) => handleSelect(field.key, e.target.value)"
            class="form-select"
          >
            <option value="">Не выбрано</option>
            <option
              v-for="opt in field.options"
              :key="opt"
              :value="opt"
            >
              {{ opt }}
            </option>
          </select>

          <div v-else class="multiple-select">
            <label
              v-for="opt in field.options"
              :key="opt"
              class="checkbox-option"
            >
              <input
                type="checkbox"
                :checked="selections[field.key].includes(opt)"
                @change="(e) => handleCheckbox(field.key, opt, e.target.checked)"
              >
              <span class="checkbox-label">{{ opt }}</span>
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="right-panel self-save-block">
      <mcw-checkbox
        v-model="showConstructor"
        :label="showConstructor ? 'Скрыть конструктор' : 'Показать конструктор'"
      />
      <mcw-textfield
        ref="adminCommentField"
        outline
        v-model="finalText"
        @blur="onTextBlur"
        label="Инструкции для администраторов мед. центра"
        rows="8"
        multiline
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContractForm',
  props: {
    text: {
      type: String,
      default: '',
    },
  },
  emits: ['handleUpdateAdminComment'],
  data() {
    return {
      showConstructor: false,
      rawData: [
        [
          'Суть договора (выбрать несколько)',
          'Внесение',
          'Оплата',
          'Заключение',
          'Анализы',
          'ФГДС/маммография',
          'ЛМК (выбрать несколько)',
          'ДОП УСЛУГИ (выбрать несколько)',
          'СПРАВКА О ЯВКЕ',
          'Прививки',
          'Морская комиссия (выбрать несколько)',
          'УМО (выбрать несколько)',
          'ВАЖНО',
        ],
        [
          'Предварительный осмотр',
          'не внесен-не принимаем',
          'нал',
          'ну руки пациенту',
          'не принимаем',
          'ставим долг',
          'ЛМК с фото',
          '',
          'нужна',
          'Делаем или пишут отказ',
          '714',
          'записываются самостоятельно, заключение выдает кардиолог на месте',
          'описание',
        ],
        [
          'Периодический осмотр',
          'невнесенных согласовываем с менеджером',
          'безнал',
          'менеджеру',
          'только свои',
          'ФГДС долг/ММГ заменяем на узи мж',
          'ЛМК без фото',
          '',
          'не нужна',
          'не нужны',
          '714 + MLC без фото',
          'без записи, заключение выдает кардиолог на месте',
          '',
        ],
        [
          'ОПО',
          'принимаем по направлениям без печати',
          'на направлении',
          '',
          '',
          'ФГДС долг не ставим/ММГ заменяем на узи мж',
          'без ЛМК',
          'ХТИ',
          '',
          '',
          '714 + MLC с фото',
          'записываются самостоятельно, заключение у менеджера',
          '',
        ],
        [
          'плавсостав',
          '',
          '',
          '',
          '',
          'ФГДС долг не ставим/ММГ долг',
          'по направлению',
          '086У',
          '',
          '',
          'drug alcohol test на русском',
          'без записи, заключение у менеджера',
          '',
        ],
        [
          'ЛМК',
          '',
          '',
          '',
          '',
          '',
          'несколько гигаттестаций',
          'Антитела к кори',
          '',
          '',
          'drug alcohol test на английском',
          'прохождение за 1 визит',
          '',
        ],
        [
          'Вакцинация',
          '',
          '',
          '',
          '',
          '',
          'комплекс 6193',
          'Свой вариант',
          '',
          '',
          '',
          'прохождение за 2 визита',
          '',
        ],
        [
          'УМО',
          '',
          '',
          '',
          '',
          '',
          'комплекс 6474',
          '',
          '',
          '',
          '',
          '',
          '',
        ],
        [
          'ФЛГ',
          '',
          '',
          '',
          '',
          '',
          'комплекс 6476',
          '',
          '',
          '',
          '',
          '',
          '',
        ],
        [
          'Свой вариант',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
        ],
      ],
      fields: [],
      selections: {},
      finalText: '',
      manualParts: new Map(),
    };
  },

  created() {
    this.parseExcelData();
    this.initFromProps();
  },

  watch: {
    text(newVal) {
      if (newVal !== this.finalText) {
        this.initFromProps();
      }
    },
  },

  methods: {
    onTextBlur() {
      this.parseFromText();
      this.rebuildText();
    },

    onKeydown(e) {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        this.onTextBlur();
      }
    },

    parseExcelData() {
      const [headers, ...rows] = this.rawData;
      const indices = headers
        .map((h, i) => (h?.trim() ? i : -1))
        .filter((i) => i !== -1);

      const fields = [];
      const selections = {};

      indices.forEach((i) => {
        const raw = headers[i];
        const label = raw.replace(/ \(выбрать несколько\)$/, '');
        const multiple = raw.includes('(выбрать несколько)');
        const key = label.toLowerCase().replace(/[^а-яa-z0-9]/g, '_');

        const options = [
          ...new Set(
            rows
              .map((r) => r[i])
              .filter(Boolean)
              .map((s) => s.trim())
              .filter(Boolean),
          ),
        ];

        selections[key] = multiple ? [] : '';
        fields.push({
          key, label, options, multiple,
        });
      });

      this.fields = fields;
      this.selections = selections;
    },

    initFromProps() {
      this.finalText = this.text || '';
      this.manualParts.clear();
      this.resetSelections();
      this.parseText();
      this.rebuildText();
    },

    resetSelections() {
      this.fields.forEach((f) => {
        this.selections[f.key] = f.multiple ? [] : '';
      });
    },

    parseText() {
      if (!this.finalText.trim()) return;

      const fieldMap = Object.fromEntries(
        this.fields.map((f) => [f.label, f]),
      );

      this.manualParts.clear();
      this.resetSelections();

      this.finalText.split('///').forEach((block) => {
        const trimmed = block.trim();
        if (!trimmed) return;

        const colon = trimmed.indexOf(':');
        if (colon === -1) return;

        const label = trimmed.slice(0, colon).trim();
        const value = trimmed.slice(colon + 1).trim();
        const field = fieldMap[label];
        if (!field) return;

        const matched = field.options.filter((opt) => {
          const escaped = this.escape(opt);
          const regex = new RegExp(`(^|[,\\s])${escaped}([,\\s]|$)`);
          return regex.test(value);
        });

        if (field.multiple) {
          this.selections[field.key] = [...new Set(matched)];
        } else if (matched.length > 0) {
          [this.selections[field.key]] = matched;
        }

        const manual = this.removeKnownOptions(value, field.options);
        this.manualParts.set(field.key, manual);
      });
    },

    removeKnownOptions(text, options) {
      let result = text;

      options.forEach((opt) => {
        const escaped = this.escape(opt);

        const regex = new RegExp(
          `(^|[,\\s])${escaped}([,\\s]|$)`,
          'gi',
        );
        result = result.replace(regex, (match, before, after) => {
          const commaBefore = before === ',' ? ',' : '';
          const commaAfter = after === ',' ? ',' : '';
          return commaBefore || commaAfter ? ',' : '';
        });
      });

      return result
        .replace(/,\s*,/g, ',')
        .replace(/^,\s*|\s*,$/g, '')
        .replace(/\s+,/g, ',')
        .replace(/,\s+/g, ', ')
        .replace(/\s+/g, ' ')
        .trim();
    },

    escape(str) {
      return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },

    rebuildText() {
      const newParts = [];

      this.fields.forEach((field) => {
        const selected = this.selections[field.key];
        // eslint-disable-next-line no-nested-ternary
        const selectedText = field.multiple
          ? (Array.isArray(selected) && selected.length > 0 ? selected.join(', ') : '')
          : (selected || '');

        const manual = this.manualParts.get(field.key) || '';
        const hasSelected = field.multiple ? selected.length > 0 : !!selected;
        const hasManual = manual.trim() !== '';

        if (hasSelected || hasManual) {
          const separator = selectedText && manual ? ', ' : '';
          const value = selectedText ? `${selectedText}${separator}${manual}` : manual;
          newParts.push(`${field.label}: ${value.trim()}`);
        }
      });

      if (this.finalText.trim()) {
        const existingLabels = this.fields.map((f) => f.label);
        this.finalText.split('///').forEach((block) => {
          const trimmed = block.trim();
          if (!trimmed) return;
          const colon = trimmed.indexOf(':');
          if (colon === -1) {
            newParts.push(trimmed);
            return;
          }
          const label = trimmed.slice(0, colon).trim();
          if (!existingLabels.includes(label)) {
            newParts.push(trimmed);
          }
        });
      }

      this.finalText = newParts.filter(Boolean).join(' /// ');

      if (!this.finalText.trim()) {
        this.finalText = '';
      }
      this.$emit('handleUpdateAdminComment', this.finalText.trim());
    },

    handleSelect(key, value) {
      this.selections[key] = value || '';
      this.rebuildText();
    },

    handleCheckbox(key, option, checked) {
      const arr = this.selections[key];
      this.selections[key] = checked
        ? [...arr.filter((x) => x !== option), option]
        : arr.filter((x) => x !== option);
      this.rebuildText();
    },

    parseFromText() {
      this.parseText();
      this.rebuildText();
    },
  },
};
</script>

<style scoped>
.contract-form {
  display: flex;
  gap: 20px;
  height: 400px;
  overflow: auto;
  padding: 4px;
}

.left-panel,
.right-panel {
  flex: 1;
  overflow-y: auto;
}

.field-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 8px;
  padding: 12px;
}

.field-title {
  font-weight: 500;
  margin-bottom: 8px;
  color: #333;
}

.form-select {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.multiple-select {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.checkbox-option {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.checkbox-input {
  margin-right: 8px;
}

.self-save-block {
  position: relative;
}

.self-save-block__button {
  position: absolute !important;
  top: 50px;
  right: 0;
}
</style>
